import {
  Component,
  forwardRef,
  Injector,
  OnInit,
  AfterContentInit,
  Input,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NgControl,
} from '@angular/forms';

import { FormCommonFunctions2 } from '../form-common-functions';

@Component({
  selector: 'appForm2-list-input',
  styleUrls: ['../form.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SimpleFormList2Component),
      multi: true,
    },
  ],
  template: `
    <div class="p-col-12 p-g-nopad" style="position:relative">
      <input
        pInputText
        class="form-control"
        style="margin: 0px !important"
        [escape]="false"
        tooltipEvent="focus"
        tooltipPosition="bottom"
        [pTooltip]="control.hints || null"
        [(ngModel)]="value"
        (ngModelChange)="(ngModelChange)"
        [disabled]="disabled"
        (blur)="blurEvent()"
        [type]="htmlAttributes['input']['type']"
        (input)="pushChanges($event.target.value)"
        [class.form-control-danger]="control.showErrors || ''"
        [attr.id]="htmlAttributes['input']['id']"
        [attr.form-control-name]="control['name']"
        [attr.placeholder]="
          placeholder ||
          htmlAttributes['label']['value'] ||
          control.label ||
          null
        "
      />
      <div *ngIf="control.showErrors" class="vendium-tool-tip">
        <p
          *ngFor="let error of control['mergedErrors']"
          class="form-control-feedback"
        >
          <span><i class="fa fa-times"></i> </span
          ><span [innerHTML]="error"></span>
        </p>
      </div>
    </div>
  `,
})
export class SimpleFormList2Component
  extends FormCommonFunctions2
  implements ControlValueAccessor, OnInit, AfterContentInit
{
  value: any;
  onChange: (_: any) => void;
  onTouched: () => void;
  @Input() disabled: boolean;
  ngControl: NgControl;
  @Input() public ngModelChange: (_: any) => void;
  @Input() public placeholder: string;

  constructor(private inj: Injector) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.ngControl = this.inj.get(NgControl);
    this.control = this.ngControl;
  }

  ngAfterContentInit() {
    this.control = this.ngControl.control;
  }

  writeValue(value: any): void {
    this.value = value !== undefined ? value : null;
  }
  pushChanges(value: any) {
    this.onChange(value);
  }
  blurEvent(): void {
    this.onTouched();
    this.onBlur.emit(true);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
